import Reveal from 'stimulus-reveal-controller'
import _ from "lodash";

export default class extends Reveal {
    connect() {
        super.connect()
        console.log('Do what you want here.')
    }
}